import { defineStore } from 'pinia';
import { ref } from 'vue';

// eslint-disable-next-line import/prefer-default-export
export const useOnboardingWizardStore = defineStore('onboardingWizard', () => {
  const firstEntityId = ref<number | undefined>(undefined);
  const fintocAccountConnected = ref<boolean | undefined>(undefined);

  return {
    firstEntityId,
    fintocAccountConnected,
  };
});
